// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","status":"Tag_status__2FwzU"};